import dayjs from 'dayjs';
import React from 'react';

interface DateTimeFieldProps {
  value: string
  sourceFormat: string
  targetFormat: string
}

export const DateTimeField: React.FC<DateTimeFieldProps> = React.memo((props) => {
  const { sourceFormat, targetFormat, value } = props;
  return dayjs(value, sourceFormat).format(targetFormat);
});
